import { FC, ReactNode } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthenticatedLayout } from "@Layout/AuthenticatedLayout";
import { InicioPage } from "@Pages/Inicio";
import { NovaConsultaPage } from "@Pages/NovaConsulta";
import { HistoricoPage } from "@Pages/Historico";
import { ResultadoPage } from "@Pages/Resultado";
import { RelatoriosPage } from "@Pages/Relatorios";
import { PrecosPage } from "@Pages/Precos";
import { AcessoNegado } from "@Pages/AcessoNegado";
import { LoadingScreen } from "@Components/LoadingScreen";
import { useAcesso } from "@Hooks/useAcesso";

// Gate por PAPEL: com o gate ligado, quem não tem nenhuma das duas roles não entra
// (fail-closed). Enquanto o GET /config carrega, segura num loading — não pisca a
// tela de negado nem o conteúdo. O enforcement REAL é no backend (esta é só a UX).
const AcessoGate: FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoading, gateEnabled, hasAny } = useAcesso();
  if (isLoading) return <LoadingScreen message="Verificando acesso…" />;
  if (gateEnabled && !hasAny) return <AcessoNegado />;
  return <>{children}</>;
};

export const AuthenticatedRoutes: FC = () => {
  return (
    <AcessoGate>
    <Routes>
      <Route element={<AuthenticatedLayout />}>
        <Route path="/" element={<Navigate to="/inicio" replace />} />
        <Route path="/inicio" element={<InicioPage />} />
        <Route path="/nova-consulta" element={<NovaConsultaPage />} />
        <Route path="/historico" element={<HistoricoPage />} />
        <Route path="/relatorios" element={<RelatoriosPage />} />
        <Route path="/relatorios/:slug" element={<RelatoriosPage />} />
        <Route path="/precos" element={<PrecosPage />} />
        <Route path="/precos/:slug" element={<PrecosPage />} />
        <Route path="/resultado/:token" element={<ResultadoPage />} />
        <Route path="*" element={<Navigate to="/inicio" replace />} />
      </Route>
    </Routes>
    </AcessoGate>
  );
};
